// src/services/recuperacionService.js
import api from "./Api"; // 👈 respeta la A mayúscula

// Base relativa al baseURL resuelto en Api.js (dev/prod)
const BASE = "/Usuarios/recuperacion";

// Helper para lanzar errores legibles desde axios
function throwAxiosError(err, contexto) {
  const status = err?.response?.status ?? 0;
  const body = err?.response?.data ?? err?.message ?? "";
  const msg =
    typeof body === "string" ? body.slice(0, 300) : JSON.stringify(body).slice(0, 300);
  const e = new Error(`Error al ${contexto} • HTTP ${status}: ${msg}`);
  e.status = status;
  e.body = body;
  throw e;
}

// ✅ Enviar token al correo
export async function enviarTokenRecuperacion(email) {
  try {
    const { data } = await api.post(`${BASE}/enviar-token`, { email });
    return data; // lo que devuelva tu backend (ej: { ok:true })
  } catch (err) {
    throwAxiosError(err, "enviar el token");
  }
}

// ✅ Verificar token
// ✅ Cambiar contraseña
export async function cambiarContrasena(email, token, nuevaContrasena) {
  try {
    const { data } = await api.post(`${BASE}/cambiar-contrasena`, {
      email,
      token,
      nuevaContrasena,
    });
    return typeof data === "undefined" ? true : data;
  } catch (err) {
    throwAxiosError(err, "cambiar la contraseña");
  }
}

// Export default opcional (por si te gusta importar como objeto)
const recuperacionService = {
  enviarTokenRecuperacion,
  cambiarContrasena,
};

export default recuperacionService;
